<button class="btn btn-icon btn-light" (click)="active = !active; activeChange.emit(active);">
  <tr-icon [icon]="icon.arrowUp" [size]="iconSize.regular" *ngIf="active"></tr-icon>
  <tr-icon [icon]="icon.arrowDown" [size]="iconSize.regular" *ngIf="!active"></tr-icon>
</button>
